<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">{{ $t('elTable.userInformation') }}</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          :inline="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">{{ $t('enterpriseUser.carInformation') }}</span>
      </div>
      <template>
        <div style="height: 10px;" />
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          :header-cell-style="{background:'#f5f7fa',color:'#000000'}"
        >
          <el-table-column
            :label="$t('enterpriseUser.carNumber')"
            prop="plateNumber"
            align="center"
          />
          <el-table-column
            :label="$t('enterpriseUser.allPeople')"
            prop="owner"
            align="center"
          />
          <el-table-column
            :label="$t('enterpriseUser.carType')"
            align="center"
            prop="type"
          />
          <el-table-column
            :label="$t('enterpriseUser.brandModel')"
            align="center"
            prop="model"
          />
          <el-table-column
            :label="$t('enterpriseUser.carCode')"
            align="center"
            prop="vin"
          />
          <template slot="empty">
            <div style="display: flex;justify-content: center;align-items: center;">
              <div>{{ $t('commonly.noData') }}</div>
            </div>
          </template>
        </el-table>
      </template>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">驾驶证信息</span>
      </div>
      <template>
        <div style="height: 10px;" />
        <el-table
          :data="tableDataDrivingLicense"
          stripe
          style="width: 100%"
          :header-cell-style="{background:'#f5f7fa',color:'#000000'}"
        >
          <el-table-column
            label="证号"
            prop="num"
            align="center"
          />
          <el-table-column
            label="姓名"
            prop="name"
            align="center"
          />
          <el-table-column
            label="准驾车型"
            align="center"
            prop="vehicle_type"
          />
          <el-table-column
            label="有效期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.start_date }}至{{ scope.row.end_date }}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div style="display: flex;justify-content: center;align-items: center;">
              <div>无数据</div>
            </div>
          </template>
        </el-table>
      </template>
    </el-card>
  </div>
</template>

<script>
import { regionData, provinceAndCityData } from 'element-china-area-data'
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Qiyexiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: '用户账号',
          type: 'div',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          type: 'div',
          prop: 'userName'
        },
        {
          label: '归属企业',
          type: 'div',
          prop: 'org'
        },
        {
          label: '手机号',
          type: 'div',
          prop: 'phoneNum'
        },
        {
          label: '用户卡号',
          type: 'div',
          prop: 'cardNum'
        },
        {
          label: '归属城市',
          type: 'divCascader',
          prop: 'cityCode',
          data: provinceAndCityData
        },
        {
          label: '指定SOC停充开关',
          type: 'div',
          prop: 'socSwitch'
        },
        {
          label: 'SOC停充阈值',
          type: 'div',
          prop: 'socThreshold',
          unit: '%'
        },
        {
          label: '状态',
          type: 'div',
          prop: 'status'
        }
      ],
      id: '',
      tableData: [],
	  tableDataDrivingLicense: []
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeMount() {
    this.id = this.$route.query.data
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    getDataDetail(val) {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/user/account/getDataDetail',
        method: 'get',
        data: data,
        callback: resp => {
          this.rowdata = resp
          this.rowdata.cityCode = resp.cityCode ? resp.cityCode.split(',') : []
          this.tableData = resp.list
		  this.tableDataDrivingLicense = resp.drivingLicenses
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  /deep/.el-card:last-child{
    margin-top: 20px;
  }
  /deep/.el-table th.is-leaf{
    border-bottom:none !important;
  }
  /deep/.el-card:last-child .el-card__body{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/userManagement/detailEnterprise.vue